<template>
    <div>
        <el-dialog title="" :visible.sync="detailsShow" :close-on-click-modal="false" width="700px" ref="dialog"
            @close="invoiceClose" top="5vh">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="新闻标题" prop="name">
                    <el-input v-model.trim="ruleForm.name" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="新闻类型" prop="type">
                    <el-select size="mini" v-model="ruleForm.type" placeholder="请选择新闻类型">
                        <el-option value="" label="请选择"></el-option>
                        <el-option :value="item.newstypeid" :label="item.name" v-for="(item, index) in newsTypeArr"
                            :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="ruleForm.status">
                        <el-radio :label="1">有效</el-radio>
                        <el-radio :label="0">作废</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否置顶" prop="istop">
                    <el-radio-group v-model="ruleForm.istop">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="文章封面" prop="mask" class="mask">
                    <el-upload class="show" :class="{ hide: hideUploadCover }" :action="url" list-type="picture-card"
                        :limit="3" :file-list="fileListCover" :on-change="dealImgChangeCover"
                        :on-remove="handleDealImgRemoveCover" :on-success="handleAvatarSuccessCover"
                        :on-preview="handlePictureCardPreview" 
                        accept=".jpg, .jpeg, .png"
                        :before-upload="uploadPreview">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="tips">注:请上传图片格式,大小不超过5MB</span>
                </el-form-item>
                <el-form-item label="链接网址" prop="address">
                    <el-input v-model.trim="ruleForm.address" placeholder="https://xxxxxxxxxx"></el-input>
                </el-form-item>
                <el-form-item label="新闻简介" prop="desc">
                    <el-input type="textarea" v-model.trim="ruleForm.desc"></el-input>
                </el-form-item>
                <el-form-item>
                    <!-- <el-button type="primary" @click="submitForm('ruleForm')"  v-if="!id">立即创建</el-button>
                    <el-button type="primary" @click="editForm('ruleForm')" v-if="id">编辑</el-button> -->
                    <!-- <el-button @click="resetForm('ruleForm')" type="success">重置</el-button> -->
                    <el-button type="primary" @click="save()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import apiEnv from "@/service/apiEnv.js";
    import {
        newsType,
        addNews,
        getNewsById,
        editNews
    } from "@/service/newsApi";
    export default {
        data() {
            return {
                detailsShow: false, //详情dialog
                ruleForm: {
                    name: "",
                    type: "",
                    status: "",
                    istop: "",
                    desc: "",
                    address: "",
                },
                rules: {
                    name: [{
                            required: true,
                            message: "请输入新闻标题",
                            trigger: "blur",
                        },
                        {
                            min: 3,
                            max: 100,
                            message: "长度在 3 到 100 个字符",
                            trigger: "blur",
                        },
                    ],
                    type: [{
                        required: true,
                        message: "请选择新闻类型",
                        trigger: "change",
                    }, ],
                    status: [{
                        required: true,
                        message: "请选择状态",
                        trigger: "change",
                    }, ],
                    istop: [{
                        required: true,
                        message: "请选择是否置顶",
                        trigger: "change",
                    }, ],
                    desc: [{
                            required: true,
                            message: "请输入新闻简介",
                            trigger: "blur",
                        },
                        {
                            min: 1,
                            max: 100,
                            message: "长度在 1 到 100 个字符",
                            trigger: "blur",
                        },
                    ],
                    address: [{
                        required: true,
                        message: "请输入链接网址",
                        trigger: "blur",
                    }, ],
                },
                //s上传
                hideUploadCover: false,
                fileListCover: [],
                dialogImageUrl: "", //封面图
                limitCount: 3,
                DialogsImageUrlCover: [],
                //e上传
                url: apiEnv.uploadURL,
                newsTypeArr: [],
                oraginForm:{},
                id:'',
            };
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.ruleForm));
            this.getNewsType();
        },
        methods: {
            getNewsType() {
                let data = {
                    pageNum: 1,
                    pageSize: 999,
                    rational: false,
                };
                newsType(data).then((r) => {
                    if (r.Result != 1) {
                        return this.$message.error("列表异常,请联系管理员");
                    }
                    this.newsTypeArr = r.Data.datas;
                });
            },
            open(id) {
                const _this = this
                if(id){this.id = id}else{
                    this.id = ""
                }
                
                this.resetForm('ruleForm')
                if(id){
                    var params = {
                        newsid : id
                    }
                    getNewsById(params).then((r)=>{
                        if (r.Result != 1) {
                            return this.$message.error("无法加载详情,请联系管理员");
                        }
                        const {Data} = r
                        _this.ruleForm = {
                            name:Data.title,
                            type:Data.newstypeid,
                            status:Data.statu,
                            istop:Data.istop,
                            address:Data.url,
                            desc:Data.introduce,
                        }
                        let objCover = {};
                        _this.fileListCover = [];
                        _this.DialogsImageUrlCover = []
                        var tempArr = Data.imageUrlList || []
                        if(tempArr.length>0){
                            for(var i=0;i<tempArr.length;i++){
                                // objCover.url = tempArr[i]
                                _this.DialogsImageUrlCover.push(tempArr[i])
                                _this.fileListCover.push({
                                url:tempArr[i]
                            });
                            }
                            
                        }
                        if(tempArr.length>=3){
                            this.hideUploadCover = true;
                        }else{
                            this.hideUploadCover = false;
                        }
                        // if (Data.imageurl) {
                        //     objCover.url = Data.imageurl;
                        //     this.fileListCover.push(objCover);
                        //     this.hideUploadCover = true;
                        //     this.DialogsImageUrlCover = Data.imageurl;
                        // }
                        this.detailsShow = true;
                    })
                }
                if(!id){
                    this.detailsShow = true;
                }
                
            },
            invoiceClose() {
                this.detailsShow = false;
            },
            save(){
                if(this.id){
                    this.editForm('ruleForm')
                }
                if(!this.id){
                    this.submitForm('ruleForm')
                }
            },
            editForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        this.$message.error("请完善表单");
                        return;
                    }
                    if (this.DialogsImageUrlCover.length<=0) {
                        this.$message.error("请上传封面");
                        return;
                    }
                    if(!this.jugeUrl(this.ruleForm.address)){
                        this.$message.error('链接网址不是有效网址')
                        return;
                    }
                    var params = {
                        imageUrlList: this.DialogsImageUrlCover,
                        introduce: this.ruleForm.desc,
                        istop: this.ruleForm.istop,
                        newsid:this.id,
                        newstypeid: this.ruleForm.type,
                        statu: this.ruleForm.status,
                        title: this.ruleForm.name,
                        url: this.ruleForm.address,
                        source:1,
                    };
                    editNews(params).then((r) => {
                        if (r.Result != 1) {
                            return this.$message.error("提交失败,请联系管理员");
                        }
                        this.$message.success("编辑成功");
                        this.detailsShow = false;
                        this.$parent.GetNewsList();
                    });
                });
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        this.$message.error("请完善表单");
                        return;
                    }
                    if (this.DialogsImageUrlCover.length<=0) {
                        this.$message.error("请上传封面");
                        return;
                    }
                    if(!this.jugeUrl(this.ruleForm.address)){
                        this.$message.error('链接网址不是有效网址')
                        return;
                    }
                    var params = {
                        imageUrlList: this.DialogsImageUrlCover,
                        introduce: this.ruleForm.desc,
                        istop: this.ruleForm.istop,
                        newstypeid: this.ruleForm.type,
                        statu: this.ruleForm.status,
                        title: this.ruleForm.name,
                        url: this.ruleForm.address,
                        source:1,
                    };
                    addNews(params).then((r) => {
                        if (r.Result != 1) {
                            return this.$message.error("提交失败,请联系管理员");
                        }
                        this.$message.success("创建成功");
                        this.detailsShow = false;
                        this.$parent.GetNewsList();
                    });
                });
            },
            resetForm(formName) {
                if(this.$refs[formName]) this.$refs[formName].resetFields();
                this.ruleForm = JSON.parse(JSON.stringify(this.oraginForm));
                this.fileListCover = [];
                            this.hideUploadCover = false;
                            this.DialogsImageUrlCover = [];
            },
            jugeUrl(URL) {
            var str = URL;
            //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
            //下面的代码中应用了转义字符"\"输出一个字符"/"
            //var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;

            var Expression = `^http(s){0,1}://[^/:]+(:\\d+){0,1}`;


            var objExp = new RegExp(Expression);
            if (objExp.test(str) == true) {
                return true;
            } else {
                return false;
            }
        },
            //s上传
            uploadPreview(file) {
                const isLt5M = file.size / 1024 / 1024 < 5;

                
                if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB!');
                }
                return isLt5M;
            },
            dealImgChangeCover(file, fileList) {
                this.hideUploadCover = fileList.length >= this.limitCount;
            },
            //删除上传文件Cover
            handleDealImgRemoveCover(file, fileList) {
                this.DialogsImageUrlCover = []
                this.hideUploadCover = fileList.length >= this.limitCount;
                this.fileListCover = fileList;
                for(var i=0;i<fileList.length;i++){
                    this.DialogsImageUrlCover.push(fileList[i].response.Data[0].imgUrl)
                }
                
            },
            //上传成功Cover
            handleAvatarSuccessCover(res, file, fileList) {
                this.DialogsImageUrlCover = []
                if (res.Result != 1) {
                    this.fileListCover = [];
                    return this.$message.error(res.Message);
                }
                this.fileListCover = fileList;
                for(var i=0;i<fileList.length;i++){
                    this.DialogsImageUrlCover.push(fileList[i].response.Data[0].imgUrl)
                }
            },
            //点击图片查看
            handlePictureCardPreview(file) {
                this.dialogImageUrl = "";
                this.dialogImageUrl = file.response ?
                    file.response.Data[0].imgUrl :
                    file.url;
                this.dialogVisible = true;
            },
            //e上传
        },
    };
</script>
<style lang="scss">
    .hide .el-upload--picture-card {
        display: none;
    }

    .mask {
        position: relative;

        .tips {
            position: absolute;
            left: 0;
            bottom: -30px;
        }
    }

    .el-form-item {
        margin-bottom: 30px !important;
    }

    .mask {
        .el-form-item__label::before {
            content: "*";
            font-size: 12px;
            color: #f56c6c;
            display: inline-block;
            margin-right: 4px;
        }
    }
</style>